import {
	ISendGridTemplate,
	ISendGridTemplateReplicationRequest
} from '@/models/templates';
import { get, post } from '../../axiosprovider';

const getSendGridTemplate = async (payload: {
	id: string;
	environment?: string;
}): Promise<ISendGridTemplate> => {
	return await get<ISendGridTemplate>(
		`/api/templates/email/id/${payload.id}/${
			payload.environment ?? ''
		}`.trim()
	);
};

const getSendGridTemplateByName = async (payload: {
	name: string;
	environment?: string;
}): Promise<ISendGridTemplate> => {
	return await get<ISendGridTemplate>(
		`/api/templates/email/name/${payload.name}/${
			payload.environment ?? ''
		}`.trim()
	);
};

const getSendGridTemplates = async (
	environment?: string
): Promise<ISendGridTemplate[]> => {
	return await get<ISendGridTemplate[]>(
		`/api/templates/email/${environment ?? ''}`.trim()
	);
};

const postReplicateSendGridTemplate = async (
	request: ISendGridTemplateReplicationRequest
): Promise<void> => {
	return await post<ISendGridTemplateReplicationRequest, void>(
		'/api/templates/email/replication',
		request
	);
};

export const templatesController = {
	getSendGridTemplate,
	getSendGridTemplateByName,
	getSendGridTemplates,
	postReplicateSendGridTemplate
};
